import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 200 条件分歧？
 */
class EventAd extends EventBase {
  public constructor() {
    super()
    this.Parameter = ['']
  }

  /**
   * 事件Id
   */
  public Code = EventID.Ad

}
export default EventAd
